import { useSearchParams } from "react-router-dom";
import Seo from "../components/Seo";
import { PageHero } from "../components/common/Section";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { SipCalculator, LumpsumCalculator, CompoundCalculator } from "../components/calculators/GrowthCalculators";
import { RetirementCalculator, InsuranceCalculator, GoalCalculator } from "../components/calculators/PlanningCalculators";
import RiskProfile from "../components/calculators/RiskProfile";

const TABS = [
  ["sip", "SIP", SipCalculator],
  ["mutual-fund", "MF Returns", LumpsumCalculator],
  ["compound", "Compound Interest", CompoundCalculator],
  ["retirement", "Retirement", RetirementCalculator],
  ["insurance", "Insurance Cover", InsuranceCalculator],
  ["goal", "Goal Planner", GoalCalculator],
  ["risk", "Risk Profile", RiskProfile],
];

export default function Calculators() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.some(([k]) => k === params.get("tool")) ? params.get("tool") : "sip";
  return (
    <>
      <Seo title="Financial Calculators" path="/calculators" description="SIP, mutual fund, compound interest, retirement, insurance and goal calculators plus a risk profile assessment." />
      <PageHero eyebrow="Smart Financial Tools" title="Financial Calculators" text="Interactive tools to explore scenarios. All outputs are illustrative projections, not guaranteed returns." />
      <section className="bg-slate-100/70 py-16">
        <div className="container-q">
          <Tabs value={tab} onValueChange={(v) => setParams({ tool: v }, { replace: true })}>
            <TabsList className="mb-8 flex h-auto flex-wrap justify-start gap-2 bg-transparent p-0">
              {TABS.map(([k, label]) => (
                <TabsTrigger key={k} value={k} data-testid={`calc-tab-${k}`}
                  className="rounded-full border border-slate-200 bg-white px-5 py-2.5 text-sm font-medium text-slate-600 data-[state=active]:border-navy data-[state=active]:bg-navy data-[state=active]:text-white">{label}</TabsTrigger>
              ))}
            </TabsList>
            {TABS.map(([k, , C]) => <TabsContent key={k} value={k} className="mt-0"><C /></TabsContent>)}
          </Tabs>
        </div>
      </section>
    </>
  );
}
